var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.75V3.95C13.75 2.8299 13.75 2.26984 13.532 1.84202C13.3403 1.46569 13.0343 1.15973 12.658 0.967987C12.2302 0.75 11.6701 0.75 10.55 0.75H8.95C7.82989 0.75 7.26984 0.75 6.84202 0.967987C6.46569 1.15973 6.15973 1.46569 5.96799 1.84202C5.75 2.26984 5.75 2.8299 5.75 3.95V4.75M7.75 10.25V15.25M11.75 10.25V15.25M0.75 4.75H18.75M16.75 4.75V15.95C16.75 17.6302 16.75 18.4702 16.423 19.112C16.1354 19.6765 15.6765 20.1354 15.112 20.423C14.4702 20.75 13.6302 20.75 11.95 20.75H7.55C5.86984 20.75 5.02976 20.75 4.38803 20.423C3.82354 20.1354 3.3646 19.6765 3.07698 19.112C2.75 18.4702 2.75 17.6302 2.75 15.95V4.75",
    stroke: "#FF2D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/IconTrash.6c2391233c2eda91a0bf74929b2f2263.svg";
export { ForwardRef as ReactComponent };